export default function mapCheckboxValue(checkBoxData) {
  for (let key in checkBoxData) {
    checkBoxData[key] = checkBoxData[key].map((item) => {
      if (item.checked) {
        return `${item.value}1`;
      } else {
        return `${item.value}0`;
      }
    });
    checkBoxData[key] = checkBoxData[key].join("");
  }
  return checkBoxData;
}
